import { render, staticRenderFns } from "./RevenueGoals.vue?vue&type=template&id=1c6abfa9&"
import script from "./RevenueGoals.vue?vue&type=script&lang=js&"
export * from "./RevenueGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports